export class InMemoryStorage {
  constructor() {
    let store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.store = store;
  }
  getItem(key) {
    if (key in this.store) {
      return this.store[key];
    }
    return null;
  }
  removeItem(key) {
    delete this.store[key];
  }
  setItem(key, value) {
    this.store[key] = value;
  }
}